import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface DragIconPropsType {
    className?: string
}

const SvgElement = styled('svg', { label: 'SvgElement' })<DragIconPropsType>`
    height: auto;
`;

export const DragIcon = observer('DragIcon', ({className}: DragIconPropsType): React.ReactElement => {
    return (
        <SvgElement
            className={className}
            width='24'
            height='24'
            fill='#fff'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle cx={10} cy={6} r={2} fill='#fill' />
            <circle cx={15} cy={6} r={2} fill='#fill' />
            <circle cx={10} cy={12} r={2} fill='#fill' />
            <circle cx={15} cy={12} r={2} fill='#fill' />
            <circle cx={10} cy={18} r={2} fill='#fill' />
            <circle cx={15} cy={18} r={2} fill='#fill' />
        </SvgElement>
    );
});
